// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"EU2_TheComp__VhIRL"};